import { ActionButton } from '../../detail/actionRowButtons/ActionButton';
import { listFilterType } from './FilterState';
import { ListTranslationKeys } from '../../../api/models/TranslationKeys';

/**
 *  @property {listFilterType} filterType
 *  @property {FilterState} filterState
 *  @property actionHandlerType
 */
export class ListFilterButton extends ActionButton {
  _init() {
    this.label = this.getTitle();
    this.actionHandler = new this.actionHandlerType(
      this._backend,
      this.filterState,
      this.focusPast,
      this.pastAndFuture
    );
    this.filterState.subscribe(() => (this.label = this.getTitle()));
  }

  getTitle() {
    const currentState = this.filterState.stateOf(this.filterType);
    if (currentState) {
      return currentState.text;
    } else {
      return this._getDefaultText(this.filterType);
    }
  }

  _getDefaultText(type) {
    switch (type) {
      case listFilterType.day:
        return this._backend.translations.forKey(ListTranslationKeys.lists_filter_day);
      case listFilterType.channel:
        return this._backend.translations.forKey(ListTranslationKeys.lists_filter_channel);
      case listFilterType.tag:
        return this._backend.translations.forKey(ListTranslationKeys.lists_filter_category);
      case listFilterType.accessibility:
        return this._backend.translations.forKey(ListTranslationKeys.lists_filter_accessibility);
    }
  }
}
